import isJSON from 'validator/lib/isJSON'
import { i18n } from '@/i18n'

export default Validator => {
  Validator.register(
    'json',
    function(value) {
      return isJSON(value)
    },
    i18n.t('invalid', { x: ':attribute' }),
  )
}
